import { useState } from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Cell
} from "recharts";
import "../App.css";


export default function ReusableBarChart({ data, metric }) {
  const [hoveredIndex, setHoveredIndex] = useState(null);


  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart
        data={data}
        barCategoryGap={18}
        barGap={6}
        onMouseLeave={() => setHoveredIndex(null)}
      >
        <CartesianGrid strokeDasharray="3 3" vertical={false} />
        <XAxis dataKey="period" />
        <YAxis />
        <Tooltip cursor={false}/>

        <Bar
          dataKey={metric}
          barSize={24}                 // small bar width
          radius={[6, 6, 0, 0]}
          animationDuration={700}
          animationEasing="ease-out"
        >
          {data.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={
                hoveredIndex === null
                  ? "#3b82f6"            // default dark blue
                  : hoveredIndex === index
                  ? "#1e3a8a"            // hovered bar
                  : "#e5e7eb"            // fade others
              }
              onMouseEnter={() => setHoveredIndex(index)}
            />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
